import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center pt-20">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20of%20fashion%20textiles%20and%20accessories%20arranged%20in%20gentle%20waves%20on%20warm%20sand%20colored%20surface%20soft%20diffused%20top%20lighting%20creating%20subtle%20gradients%20editorial%20aesthetic%20minimal%20yet%20rich%20texture%20warm%20cream%20beige%20and%20terracotta%20tones%20no%20faces&width=1600&height=900&seq=hero-bg-002&orientation=landscape&nocache=true"
          alt="Itaobuy Spreadsheet Italia - Prodotti selezionati"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative w-full px-6 md:px-10 lg:px-20 z-10">
        <div className="max-w-4xl">
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 text-background-50 text-xs md:text-sm font-medium mb-6">
            <i className="ri-sparkling-line"></i>
            <span>Il database italiano pi&ugrave; completo</span>
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5 max-w-3xl">
            Itaobuy Spreadsheet Italia: trova i migliori prodotti con dati aggiornati e controllo qualit&agrave;
          </h1>

          <p className="text-base md:text-lg text-background-50/80 leading-relaxed max-w-2xl mb-8">
            Il database pi&ugrave; completo per scoprire prodotti selezionati, immagini QC, informazioni dettagliate e consigli pratici prima dei tuoi acquisti.
          </p>

          <div className="flex flex-col sm:flex-row items-start gap-3.5">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
            >
              <span>Esplora Itaobuy Spreadsheet</span>
              <i className="ri-arrow-right-up-line text-base"></i>
            </a>
            <a
              href="/guida-itaobuy-spreadsheet"
              className="flex items-center gap-2 px-6 py-3 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 font-medium text-sm hover:bg-background-50/25 transition-all cursor-pointer whitespace-nowrap"
            >
              <span>Guida per principianti</span>
              <i className="ri-arrow-right-line text-base"></i>
            </a>
          </div>

          <div className="flex flex-wrap items-center gap-5 mt-8">
            {['Database aggiornato', 'Foto QC disponibili', 'Guide in italiano', 'Consigli di sicurezza'].map((label) => (
              <div key={label} className="flex items-center gap-1.5 text-background-50/70 text-xs md:text-sm">
                <i className="ri-check-line text-primary-400"></i>
                <span>{label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}